<div class="dialog">
  <h4 mat-dialog-title>{{ variables?.aiGenerateDialogTitle || 'Generar actividades con IA' }}</h4>
  <div class="dialog-box-s">
    <mat-dialog-content class="mt-3">

      <p class="dialog-description">{{ variables?.aiGenerateDialogDescription || 'Sube un documento funcional para que la IA pueda sugerir las macro-actividades y subtareas relevantes del catálogo.' }}</p>

      <div class="upload-section">
        <label class="upload-label">{{ variables?.uploadFunctionalDocument || 'Documento funcional' }}</label>
        <div class="upload-area">
          <input
            type="file"
            accept=".pdf,.doc,.docx,.txt"
            (change)="onFileSelected($event)"
            #fileInput
            style="display:none"
            id="ai-file-input"
          />
          <label for="ai-file-input" class="upload-btn-label">
            <mat-icon>upload_file</mat-icon>
            {{ selectedFile ? selectedFile.name : (variables?.chooseFile || 'Seleccionar archivo (.pdf, .doc, .docx, .txt)')}}
          </label>
        </div>

        @if (isUploading) {
          <div class="status-row">
            <mat-spinner diameter="20"></mat-spinner>
            <span class="status-text">{{ variables?.uploadingFile || 'Subiendo archivo...' }}</span>
          </div>
        }

        @if (uploadedFilePath && !isUploading) {
          <div class="status-row success-row">
            <mat-icon class="success-icon">check_circle</mat-icon>
            <span class="status-text success-text">{{ variables?.fileUploadedSuccessfully || 'Archivo subido correctamente.' }}</span>
          </div>
        }

        @if (uploadError) {
          <div class="status-row error-row">
            <mat-icon class="error-icon">error</mat-icon>
            <span class="status-text error-text">{{ uploadError }}</span>
          </div>
        }
      </div>

      @if (isGenerating) {
        <div class="status-row mt-3">
          <mat-spinner diameter="20"></mat-spinner>
          <span class="status-text">{{ variables?.generatingActivities || 'Generando actividades...' }}</span>
        </div>
      }

      @if (generateError) {
        <div class="status-row error-row mt-2">
          <mat-icon class="error-icon">error</mat-icon>
          <span class="status-text error-text">{{ generateError }}</span>
        </div>
      }

    </mat-dialog-content>

    <mat-dialog-actions class="button-group mt-3">
      <app-button typeBtn="secondary" color="red"
        message="{{ variables?.cancel || 'Cancel' }}"
        (click)="cancel()"></app-button>
      <app-button typeBtn="primary"
        [disabled]="!canGenerate()"
        message="{{ variables?.generate || 'Generate' }}"
        (click)="generate()"></app-button>
    </mat-dialog-actions>
  </div>
</div>
